// extracted by mini-css-extract-plugin
export var actions = "_r0-4";
export var item = "_r0-1";
export var price = "_r0-3";
export var quantity = "_r0-2";
export var table = "_r0-0";